// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 33524 ? "app" : chunkId) + "." + {"4120":"10ce2bdb4c854c95a31d","33524":"1a1964dc9c619f366676"}[chunkId] + ".css";
};